import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { ErrorAlert, InfoAlert, SuccessAlert, WarningAlert } from '@amzn/dvui/dist/Alert'
import { Text } from '@amzn/dvui/dist/Text'
import { isEmpty } from './utils'

interface IMessageTypeMap {
  [key: string]: React.ComponentType<any>
}
const messageTypeMap: IMessageTypeMap = {
  Success: SuccessAlert,
  Info: InfoAlert,
  Warn: WarningAlert,
  Critical: ErrorAlert
}

interface ConditionalTextProps {
  Tag: React.ComponentType<any> | string
  className?: string
  message?: string | WpsRuntime.atv.wps.DVString
}
export const ConditionalText = ({ Tag, className, message }: ConditionalTextProps) => message
  ? <Tag className={className}><Text string={message} /></Tag>
  : null


interface ConditionalTextArrayProps {
  Tag: React.ComponentType<any> | string
  messages?: (string | WpsRuntime.atv.wps.DVString)[]
  className?: string
}
export const ConditionalTextArray = ({ Tag, messages, className }: ConditionalTextArrayProps) =>
  !isEmpty(messages)
    ? <>{messages!.map((message, index) => <ConditionalText Tag={Tag} message={message} className={className} key={`conditional-text-${index}`} />)}</>
    : null


interface ConditionalMessageProps {
  message?: WpsRuntime.atv.wps.Message
  className?: string
}
export const ConditionalMessage = ({ message, className }: ConditionalMessageProps) => message
  ? <ConditionalText Tag={messageTypeMap[message.type]} message={message.string} className={className} />
  : null


interface ConditionalMessagesProps {
  messages?: WpsRuntime.atv.wps.Message[]
}
export const ConditionalMessages = ({ messages }: ConditionalMessagesProps) =>
  !isEmpty(messages)
    ? <>{messages!.map((message, index) =>
      <ConditionalText Tag={messageTypeMap[message.type]} message={message.string} key={`conditional-message-${index}`} />)}</>
    : null
